/**
 * Cấu hình cho màn hình Ma trận chuyển trạng thái lịch hẹn.
 *
 * `department_type` gửi lên API chính là ID phòng ban. Chỉ 4 phòng ban dưới đây
 * được cấu hình ma trận; tên hiển thị lấy từ API /api/v1/be/departments, danh
 * sách dưới chỉ dùng làm nhãn dự phòng khi gọi API thất bại.
 */
export const TRANSITION_DEPARTMENT_IDS: number[] = [4, 7, 8, 9];

export const DEPARTMENT_FALLBACK_NAMES: Record<number, string> = {
    4: 'Phòng ban #4',
    7: 'Phòng ban #7',
    8: 'Phòng ban #8',
    9: 'Phòng ban #9',
};

export interface ScreenContextOption {
    value: number;
    label: string;
}

/**
 * Các ngữ cảnh màn hình mà API hỗ trợ, `value` chính là `screen_context`.
 * 4 = Khách hàng: dùng chung cho danh sách và chi tiết khách hàng.
 */
export const SCREEN_CONTEXTS: ScreenContextOption[] = [
    { value: 1, label: 'Lịch hẹn' },
    { value: 2, label: 'Lịch tư vấn' },
    { value: 3, label: 'Lịch thực hiện' },
    { value: 4, label: 'Khách hàng' },
];

export const DEFAULT_SCREEN_CONTEXT = 1;

export function screenContextLabel(value: number): string {
    return SCREEN_CONTEXTS.find((c) => c.value === value)?.label ?? `Màn hình #${value}`;
}
